import { useMemo } from 'react';
import { useFilter } from '../../contexts/FilterContext';
import Pill from './Pill';

const Pills = () => {
    const { selectedFilters, handleFilterChange, filterTerms } = useFilter();
    const { brands } = filterTerms || {};

    const isActive = useMemo(() => {
        return Object.values(selectedFilters).some(filter => {
            if (typeof filter === 'string') {
                return filter.length > 0;
            } else if (Array.isArray(filter)) {
                return filter.some(f => typeof f === 'string' && f.length > 0);
            }
            return false;
        });
    }, [selectedFilters]);

    const renderPills = useMemo(() => {
        return Object.entries(selectedFilters).flatMap(([filterType, filter]) => {
            if (typeof filter === 'string' && filter.length > 0) {
                return [(
                    <Pill
                        key={`${filterType}-${filter}`}
                        filter={filter}
                        filterType={filterType}
                        brands={brands}
                        handleChange={handleFilterChange}
                    />
                )];
            } else if (Array.isArray(filter)) {
                return filter.filter(f => typeof f === 'string' && f.length > 0)
                    .map((f) => (
                        <Pill
                            key={`${filterType}-${f}`}
                            filter={f}
                            filterType={filterType}
                            brands={brands}
                            handleChange={handleFilterChange}
                        />
                    ));
            }
            return [];
        });
    }, [selectedFilters, brands, handleFilterChange]);

    return (
        <div id='headless-filter-pills' className={isActive ? 'filter-pills-active' : ''}>
            {renderPills}
        </div>
    );
};

export default Pills;
